/* dashboard-rediseno, tercera vuelta (D9 de la medicion 2): EL RENGLON 2 DE A10, POR LO QUE CABE.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   A10: el chip naranja del parcial y, junto, el boton chico "Retry". El documento: el boton se queda
   solo con su icono cuando el chip y el boton CON TEXTO no caben juntos (sus "228 px" son el ejemplo);
   la etiqueta sigue para el lector de pantalla. La segunda vuelta lo decidia por un ancho fijo de la
   tarjeta, y en espanol el chip largo se cortaba con "..." junto a "Reintentar" con texto.

   Aqui se decide por lo que mide de verdad: el chip a su ancho natural (el de su texto entero), el
   boton con su texto (el texto lo mide una regla invisible con la misma letra) y lo demas que lleve el
   renglon (las figuras compactas de A14), con sus huecos. Si no cabe en el renglon, la marca
   `data-solo-icono` del renglon esconde el texto y aprieta el boton. La cuenta no depende de la marca,
   asi que no hay vaiven; el renglon mide 24 en los dos casos (nada cambia de alto). Sin
   `ResizeObserver` (jsdom) se mide una vez al pintar y la medida de jsdom es 0: el boton con texto. */
import React, { useLayoutEffect, useRef } from 'react';
import { Loader2, RotateCw } from 'lucide-react';
import ChipDeEstado from './ChipDeEstado';
import { AreaDe44, BOTON_CHICO, RENGLON_DOS_CON_BOTON, BAJA_DEL_RENGLON_DOS } from './anatomia';

// Lo que el boton chico mide ademas de su texto: 9 + 9 de relleno, 2 de borde, 14 del icono y 4 de hueco.
export const BOTON_SIN_TEXTO = 38;

export function noCabe({ ancho, chip, textoDelChip, regla, otros, hueco }) {
  // El chip a su ancho natural: lo que mide mas lo que su texto tiene escondido por el corte.
  const chipNatural = chip ? chip.offsetWidth + Math.max(0, textoDelChip ? textoDelChip.scrollWidth - textoDelChip.clientWidth : 0) : 0;
  const boton = BOTON_SIN_TEXTO + (regla ? regla.offsetWidth : 0);
  const piezas = 2 + otros.length;
  const necesita = chipNatural + boton + otros.reduce((n, el) => n + el.offsetWidth, 0) + hueco * (piezas - 1);
  return ancho > 0 && necesita > ancho + 0.5;
}

export default function RenglonDelParcial({ chipTexto, chipTestid, botonTexto, alTocar, apagado, cargando, botonTestid, children, testid }) {
  const renglon = useRef(null);
  useLayoutEffect(() => {
    const el = renglon.current;
    if (!el) return undefined;
    const medir = () => {
      const hijos = [...el.children];
      const chip = hijos.find((n) => n.hasAttribute('data-tono'));
      const regla = hijos.find((n) => n.getAttribute('data-parte') === 'regla');
      // Lo demas del renglon que ocupa lugar (un panel flotante abierto va fuera del acomodo).
      const otros = hijos.filter((n) => n !== chip && !n.getAttribute('data-parte')
        && window.getComputedStyle(n).position !== 'absolute');
      const hueco = parseFloat(window.getComputedStyle(el).columnGap) || 6;
      const decide = noCabe({ ancho: el.clientWidth, chip, textoDelChip: chip ? chip.lastElementChild : null, regla, otros, hueco });
      if (decide) el.setAttribute('data-solo-icono', '');
      else el.removeAttribute('data-solo-icono');
    };
    medir();
    if (typeof window.ResizeObserver !== 'function') return undefined;
    const observador = new window.ResizeObserver(medir);
    observador.observe(el);
    return () => observador.disconnect();
  }, [chipTexto, botonTexto]);

  return (
    <div ref={renglon} className={`${RENGLON_DOS_CON_BOTON} group/renglon`} data-testid={testid}>
      <ChipDeEstado tono="naranja" className="min-w-0 shrink overflow-hidden" testid={chipTestid} titulo={chipTexto}>
        {chipTexto}
      </ChipDeEstado>
      <button type="button" data-parte="boton" onClick={alTocar} disabled={apagado} aria-label={botonTexto}
        className={`${BOTON_CHICO} group-data-[solo-icono]/renglon:px-[5px]`} data-testid={botonTestid}>
        <AreaDe44 abajo={BAJA_DEL_RENGLON_DOS} />
        {cargando ? <Loader2 className="w-3.5 h-3.5 animate-spin" aria-hidden="true" /> : <RotateCw className="w-3.5 h-3.5" aria-hidden="true" />}
        <span className="group-data-[solo-icono]/renglon:sr-only">{botonTexto}</span>
      </button>
      {/* La regla: el texto del boton con su misma letra, invisible y fuera del acomodo (se ancla a la
          tarjeta: el renglon no se posiciona, para no cambiarle el ancla al panel de las figuras). */}
      <span data-parte="regla" aria-hidden="true"
        className="absolute left-0 top-0 invisible whitespace-nowrap pointer-events-none text-[12.5px] font-semibold">{botonTexto}</span>
      {children}
    </div>
  );
}
